import { LinearProgress } from "@mui/material";
import { useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "@myplant-io/snackbar";
import { RouteNames } from "../RouteNames";
import { useTeams } from "../state/Teams";
import { teamsAuthPopup } from "../utils/teamsAuth";
import { useAuth } from "@myplant-io/hooks";
import { API_BASE_URL } from "../constants";

const messages = defineMessages({
  logoutError: {
    id: "logout.teams.error",
    defaultMessage: "Logout failed. Please try again or reload the page.",
  },
});

export function LogoutPage() {
  const { isInTeams, isInitialized } = useTeams();
  const { refetch } = useAuth(API_BASE_URL);
  const navigate = useNavigate();
  const { showErrorMessage } = useSnackbar();
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (!isInitialized) return;

    if (isInTeams) {
      // In Teams: open a popup that navigates through the full logout chain
      // (app -> OAuth server end-session -> IdP end-session) so the upstream
      // sessions are also terminated. The popup lands on /teams-auth-complete
      // which calls notifySuccess() and closes itself.
      const logoutUrl = `/logout?redirect_uri=${encodeURIComponent(
        RouteNames.TEAMS_AUTH_COMPLETE
      )}`;
      teamsAuthPopup(logoutUrl)
        .then(() => {
          refetch();
          navigate(RouteNames.ROOT, { replace: true });
        })
        .catch(() => {
          showErrorMessage({
            message: formatMessage(messages.logoutError),
            disableClickAway: true,
          });
          navigate(RouteNames.ROOT, { replace: true });
        });
    } else {
      // Regular browser: full-page redirect to the backend logout endpoint.
      window.location.href = new URL(
        "/logout",
        window.location.href
      ).toString();
    }
  }, [
    isInitialized,
    isInTeams,
    refetch,
    navigate,
    showErrorMessage,
    formatMessage,
  ]);

  return <LinearProgress />;
}
